import React from 'react';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import { Map } from 'immutable';
import { Row, Col } from 'reactstrap';
import * as paradasActions from 'modules/paradas/action';

import { CheckBoxFieldF, TextFieldF, SliderF } from 'modules/forms/component';
import { FORM_TRAYECTO } from 'modules/forms/formConstants';
import { Field, FormSection, formValueSelector } from 'redux-form/immutable';
import { filterByPolyline } from 'core/generalFunctions';

const selector = formValueSelector(FORM_TRAYECTO);

@connect((store) => ({
  paradas: store.getIn(['paradas', 'lista']),
  paradaSubida: selector(store, 'paradaSubida'),
  paradaBajada: selector(store, 'paradaBajada'),
  paradasRadio: selector(store, 'paradasRadio'),
  todasLasParadas: selector(store, 'todasLasParadas'),
}))
class CheckList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { alertMaxWaypoints: false };
  }
  componentDidMount() {
    if (this.props.paradas.size == 0) this.props.dispatch(paradasActions.get());
  }
  selectAll = (select) => {
    const { trayectoPoly, paradasRadio, todasLasParadas } = this.props;
    if (this.props.paradas && this.props.paradas.size > 0) {
      let paradasSelected = this.props.paradasSelectMap;
      select
        ? this.props.paradas.map((parada) => {
            if (todasLasParadas || filterByPolyline(trayectoPoly, parada.getIn(['localizacion', 'lng']), parada.getIn(['localizacion', 'lat']), paradasRadio))
              paradasSelected = paradasSelected.set(parada.get('id'), parada);
          })
        : (paradasSelected = Map());
      this.props.setParada(null, null, paradasSelected);
    }
  };
  render() {
    const { paradas, paradaSubida, paradaBajada, trayectoPoly, paradasRadio, todasLasParadas, setParada, paradasSelectMap, waypoints } = this.props;
    return (
      <div>
        <Row>
          <Col md="3">
            <MaterialUI.RaisedButton
              secondary
              disabled={!trayectoPoly}
              onClick={() => this.selectAll(true)}
              className="checkListButton noPadding"
              icon={<MaterialUI.FontIcon className="fa fa-check-square-o" />}
            />
          </Col>
          <Col md="3">
            <MaterialUI.RaisedButton
              secondary
              disabled={!trayectoPoly}
              onClick={() => this.selectAll(false)}
              className="checkListButton noPadding"
              icon={<MaterialUI.FontIcon className="fa fa-square-o" />}
            />
          </Col>
          <Col md="6">
            <MaterialUI.RaisedButton
              primary={!this.props.shiftPress}
              fullWidth
              backgroundColor={this.props.shiftPress ? '#2E7D32' : null}
              labelColor="white"
              onClick={() => this.props.dispatch(paradasActions.get())}
              icon={<MaterialUI.FontIcon className={this.props.shiftPress ? 'fa fa-plus' : 'fa fa-refresh'} />}
              className="checkListButton noPadding"
            />
          </Col>
        </Row>
        <Row>
          <Col md={{ size: 8, offset: 1 }}>
            {!todasLasParadas && (
              <p>
                <span>{'Radio de paradas: '}</span>
                <span>{paradasRadio}m</span>
              </p>
            )}
            {!todasLasParadas && (
              <Field
                name="paradasRadio"
                component={SliderF}
                inputProps={{
                  disabled: todasLasParadas,
                  min: 5,
                  max: 200,
                  step: 5,
                }}
              />
            )}
          </Col>
          <Col md={{ size: 3 }}>
            <p>Todas</p>
            <Field name="todasLasParadas" component={CheckBoxFieldF} />
          </Col>
        </Row>
        <MaterialUI.Divider />
        <Row>
          <Col md="2">
            <b style={{ paddingLeft: 10 }}>Orden</b>
          </Col>
          <Col md="6">
            <b>Nombre</b>
          </Col>
          <Col md="4">
            <b>Restricción horaria</b>
          </Col>
        </Row>
        <div style={{ flex: 1, maxHeight: 450, overflowY: 'auto', marginLeft: 10, marginRight: 20 }}>
          {paradas
            .filter((p) => {
              if (!p || !p.get('localizacion')) return false;
              if (!trayectoPoly || todasLasParadas || paradasSelectMap.get(p.get('id'))) return true;
              return filterByPolyline(trayectoPoly, p.getIn(['localizacion', 'lng']), p.getIn(['localizacion', 'lat']), paradasRadio);
            })
            .sortBy((p) => !paradasSelectMap.get(p.get('id')))
            .map((item) => {
              const id = item.get('id');
              return (
                <Row key={id}>
                  <Col md="2">
                    <FormSection name="waypoints">
                      <Row>
                        <Field
                          name={id}
                          component={TextFieldF}
                          inputProps={{ inputStyle: { textAlign: 'center' }, disabled: !paradaSubida || !paradaBajada || (waypoints && waypoints.size > 19 && !waypoints.get(id)) }}
                        />
                      </Row>
                    </FormSection>
                  </Col>
                  <Col md="8">
                    <MaterialUI.Checkbox label={item.get('alias')} disabled={!paradaSubida || !paradaBajada} checked={!!paradasSelectMap.get(id)} onCheck={(e, value) => setParada(value, item)} />
                  </Col>
                  <Col md="2">
                    <FormSection name="restriccionHoraria">
                      <Row>
                        <Field name={id} component={TextFieldF} inputProps={{ disabled: !paradaSubida || !paradaBajada }} />
                      </Row>
                    </FormSection>
                  </Col>
                </Row>
              );
            })}
        </div>
      </div>
    );
  }
}

export default CheckList;



// WEBPACK FOOTER //
// src/modules/trayectos/components/checkListParadas.js